import React, { useEffect, useState } from "react";
import { useGet } from "../../services/GetService";
import Acordion from "../acordion/Acordion";
import Preview from "../preview/Preview";

const Create = ({ setShowLoading }) => {
    const [inputs, setInputs] = useGet("inputs");
    const [companies, setCompanies] = useGet("companies");
    const [dataInput, setDataInput] = useState([]);
    const [dataSelect, setDataSelect] = useState([]);
    const [editableInput, setEditableInput] = useState(false);
    const [itemEditable, setItemEditable] = useState([]);
    const [replyTo, setReplyTo] = useState(0);

    useEffect(() => {
        setShowLoading(false);
    }, []);
    return (
        <div id="create-form">
            <div className="container-fluid">
                <div className="col-12">
                    <div className="row form">
                        <div className="col-4 ">
                            <Acordion
                                inputs={inputs}
                                companies={companies}
                                dataInput={dataInput}
                                setDataInput={setDataInput}
                                dataSelect={dataSelect}
                                setDataSelect={setDataSelect}
                                editableInput={editableInput}
                                setEditableInput={setEditableInput}
                                itemEditable={itemEditable}
                                setItemEditable={setItemEditable}
                                replyTo={replyTo}
                                setReplyTo={setReplyTo}
                            />
                        </div>
                        <div className="col-8">
                            <div className="row justify-content-center">
                                <div className=" col-12 mt-3 ">
                                    <Preview
                                        dataInput={dataInput}
                                        dataSelect={dataSelect}
                                        editableInput={editableInput}
                                        setEditableInput={setEditableInput}
                                        setItemEditable={setItemEditable}
                                        replyTo={replyTo}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Create;
